import { themeStyle } from "./utils/constant";

class ThemeSwitcher {
    static myInstance = null;
    static THEME_NO_KEY = "themeNo";
    constructor() {                   
        ThemeSwitcher.myInstance = this;     
        this.btn_switch = document.getElementById("id-theme-switch-btn");    

        this.themeNo = 0;

        this.onLoad();

        this.events();
    }

    static GetInstance() {
        if(ThemeSwitcher.myInstance === null) {
            ThemeSwitcher.myInstance = new ThemeSwitcher();
        }
        return ThemeSwitcher.myInstance;
    }

    events() {  
        if(this.btn_switch !== null) {
            this.btn_switch.addEventListener("click", () => this.onToggleTheme());
        }
    }

    setTheme(themeName) {        
        //document.documentElement.className += " " + themeName;
        document.documentElement.setAttribute('data-theme', themeName);
        window.Debug_Log("ThemeSwitcher.js >>> setTheme() themeName: ", themeName);
    }

    setThemeNo(themeNo) {
        if(themeNo >= 0 && themeNo < themeStyle.length) {
            this.themeNo = themeNo;            
        }

        localStorage.setItem(ThemeSwitcher.THEME_NO_KEY, this.themeNo);

        this.setTheme(themeStyle[this.themeNo].siteValue);        
    }    

    applyThemeNo(themeNo) {
        if(themeNo >= 0 && themeNo < themeStyle.length) {
            this.themeNo = themeNo;            
        }

        this.setTheme(themeStyle[this.themeNo].siteValue);
    }

    getThemeNo() {
        return this.themeNo;
    }

    isNumeric(n) {
        if(n === undefined) {
            return false;
        }
        if(n === null) {
            return false;
        }
        return !isNaN(parseInt(n)) && isFinite(n);
    }

    onLoad() {
        //window.Debug_Log("ThemeSwitcher.js >>> onLoad() this.themeNo: ", this.themeNo);
        const themeNo = localStorage.getItem(ThemeSwitcher.THEME_NO_KEY);
        if( this.isNumeric(themeNo) ) {
            //window.Debug_Log("ThemeSwitcher.js >>> onLoad() themeNo: ", themeNo);
            this.themeNo = themeNo;      
            this.applyThemeNo(this.themeNo);     
        } else {
            const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
            window.Debug_Log("ThemeSwitcher.js >>> onLoad() darkThemeMq: ", darkThemeMq);
            if (darkThemeMq.matches) {
                this.applyThemeNo(0);
            } else {
                this.applyThemeNo(1);
            }
        }

        //window.Debug_Log("ThemeSwitcher.js >>> onLoad() this.themeNo: ", this.themeNo);
        //this.setThemeNo(this.themeNo);

       //window.Debug_Log("ThemeSwitcher.js >>> onLoad() theme Class Name: ", document.documentElement.className);
    }

    onNextTheme() {
        let themeNo = this.themeNo + 1;
        if(themeNo >= themeStyle.length) {
            themeNo = 0;
        }
       this.setThemeNo(themeNo);
    }
}

export default ThemeSwitcher;